module.exports = __webpack_public_path__ + "img/profile.ca6376a9.jpg";